<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { TemperatureRequirement } from '@/types/delivery-management'
import { temperatureRequirements } from '@/utils/delivery-management'

interface Props {
    requirement: TemperatureRequirement
    iconOnly?: boolean
}

const props = withDefaults(defineProps<Props>(), { iconOnly: false })

const { t } = useI18n()
</script>

<template>
    <span
        v-tooltip="{
            content: t(temperatureRequirements[props.requirement]),
            enabled: !props.iconOnly,
        }"
        class="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-200 ring-1 ring-blue-200 dark:ring-blue-800"
    >
        <mdi:thermometer-low
            v-if="props.requirement === TemperatureRequirement.Refrigerated"
            class="relative top-[1px] text-sm"
        />
        <mdi:snowflake-thermometer
            v-if="props.requirement === TemperatureRequirement.Frozen"
            class="relative top-[1px] text-sm"
        />
        <mdi:thermometer
            v-if="props.requirement === TemperatureRequirement.Chilled"
            class="relative top-[1px] text-sm"
        />

        <span
            v-if="!props.iconOnly"
            class="leading-none uppercase"
            v-text="t(temperatureRequirements[props.requirement])"
        />
    </span>
</template>
